import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { EASE } from "./Reveal";

export const HeroVisual = ({ label, count, scrollY }) => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [10, -10]), { stiffness: 120, damping: 18 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-12, 12]), { stiffness: 120, damping: 18 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const onLeave = () => { mx.set(0); my.set(0); };

  return (
    <motion.div
      style={{ y: scrollY, perspective: 1200 }}
      initial={{ opacity: 0, scale: 0.92 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.2, delay: 0.5, ease: EASE }}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className="relative mx-auto w-full max-w-[440px]"
      data-testid="hero-visual"
    >
      <motion.div style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }} className="relative">
        <div className="absolute -inset-8 rounded-[3rem] bg-[#8B5CF6]/30 blur-3xl" />
        <div className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-black shadow-[0_40px_120px_-40px_rgba(139,92,246,0.9)]" style={{ clipPath: "polygon(0 0, 88% 0, 100% 12%, 100% 100%, 12% 100%, 0 88%)" }}>
          <img src="/brand/logo.png" alt="Resilience Brothers" className="aspect-[1200/1084] w-full object-cover" />
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.18),transparent_45%)]" />
        </div>
        <div style={{ transform: "translateZ(60px)" }} className="glass absolute -bottom-5 -left-4 flex items-center gap-2 rounded-full border border-[var(--line)] px-4 py-2 font-mono text-xs uppercase tracking-widest text-[var(--text)] sm:-left-8">
          <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#22C55E] opacity-70" /><span className="relative h-2 w-2 rounded-full bg-[#22C55E]" /></span>
          P2P · Live
        </div>
        <div style={{ transform: "translateZ(40px)" }} className="glass absolute -right-3 top-6 rounded-2xl border border-[var(--line)] px-4 py-3 sm:-right-8">
          <p className="font-mono text-[11px] uppercase tracking-widest text-[var(--muted)]">{label}</p>
          <p className="font-display text-2xl font-black">{String(count).padStart(2, "0")}</p>
        </div>
      </motion.div>
    </motion.div>
  );
};
